<div container class="survey-card-container">
  <div class="survey-card" [ngClass]="'survey-card--' + data.themeColor">

    <!-- Title / Header -->
    <div class="survey-card__header text-center text-lg-start">
      <h2 class="survey-card__title h2 fw-extrabold text-gray-900" [innerHTML]="data.title"></h2>
    </div>

    <!-- Quote Block (Grid: Photo on left, Quote on right) -->
    <div class="survey-card__quote-wrapper d-flex flex-column flex-lg-row align-items-stretch">

      <!-- Left Column: Image placeholder or actual image with double frame effect -->
      <div class="survey-card__photo-container d-flex justify-content-center align-items-center">
        <div class="survey-card__photo-frame">
          @if (data.imageName) {
          <picture [data]="{
            image: 'survey/' + getImageBaseName(data.imageName),
            webp: true,
            altext: data.imageAlt || '',
            format: getImageExtension(data.imageName),
            fill: true,
            mobile: true,
            classes: 'object-fit-cover'
          }"></picture>
          } @else {
          <div class="survey-card__photo-placeholder d-flex justify-content-center align-items-center">
            <span class="text-muted small">Placeholder Imagen</span>
          </div>
          }
        </div>
      </div>

      <!-- Right Column: Quote Text in light grey card -->
      <div class="survey-card__quote-box bg-light flex-grow-1 d-flex flex-column justify-content-center">
        <blockquote class="survey-card__quote mb-3">
          <p class="survey-card__quote-text fst-italic fw-bold text-gray-900 mb-0" [innerHTML]="data.quoteText"></p>
        </blockquote>
        <div class="survey-card__author-info">
          <span class="survey-card__author-name fw-bold text-gray-900 d-block" [innerHTML]="data.quoteAuthor"></span>
          @if (data.quoteAuthorSub) {
          <span class="survey-card__author-sub text-muted d-block" [innerHTML]="data.quoteAuthorSub"></span>
          }
        </div>
      </div>

    </div>

    <!-- Stats / Infoboxes / Bottom Description / Button Wrapper -->
    <div class="survey-card__bottom-content">

      <!-- Stats / Infoboxes below -->
      <div class="survey-card__stats-list d-flex flex-column gap-3 pt-3 pt-lg-5 mt-3">
        @for (stat of data.stats; track stat.text) {

        <!-- Desktop Layout (d-none d-lg-flex) -->
        <div class="survey-card__stat-box d-none d-lg-flex align-items-center">
          <!-- Left side: Accent color with icon -->
          <div class="survey-card__stat-icon-wrapper d-flex justify-content-center align-items-center"
            [ngClass]="'bg-' + data.themeColor">
            <img class="survey-card__stat-icon" [src]="'/assets/img/survey/' + stat.icon + '.svg'"
              [alt]="stat.altText || ''" />
          </div>

          <!-- Right side: White background with content -->
          <div class="survey-card__stat-content flex-grow-1 bg-white">
            <p class="survey-card__stat-text mb-0 text-gray-900" [innerHTML]="stat.text"></p>
          </div>
        </div>

        <!-- Mobile Layout (d-flex d-lg-none) -->
        <div class="survey-card__stat-box survey-card__stat-box--mobile d-flex flex-column d-lg-none">
          <!-- Top Accent color bar -->
          <div class="survey-card__stat-top-bar" [ngClass]="'bg-' + data.themeColor"></div>

          <!-- Content with centered icon and text -->
          <div
            class="survey-card__stat-mobile-body d-flex flex-column align-items-center text-center bg-white flex-grow-1">
            <div class="survey-card__stat-icon-wrapper-mobile">
              <img class="survey-card__stat-icon-mobile"
                [src]="'/assets/img/survey/' + (stat.iconMobile || stat.icon) + '.svg'" [alt]="stat.altText || ''" />
            </div>
            <p class="survey-card__stat-text mb-0 text-gray-900" [innerHTML]="stat.text"></p>
          </div>
        </div>

        }
      </div>

      <!-- Bottom Description and CTA Button -->
      <div class="survey-card__footer text-start">
        @if (data.bottomDescription) {
        <p class="survey-card__description text-muted" [innerHTML]="data.bottomDescription"></p>
        }
        @if (data.button) {
        <div class="survey-card__cta d-flex justify-content-center justify-content-lg-start">
          <div global-button [buttonData]="data.button" class="w-fit"></div>
        </div>
        }
      </div>

    </div>

  </div>
</div>